export default __webpack_public_path__ + "static/media/130c444dbe124f76ceda68a9729022221599575627115.1fbefda2.webp";